import investorListTemplate from './investorList.html';
import investorListFilterModalTemplate from './investorListFilterModal.html';

import investorContactCampaignModalTemplate from './investorContactCampaignModal.html';

const investorFilterModal = {
    bindings: {
        openModal: '=',
        onSearch: '=',
        onSort: '=',
        investorType: '=',
        teamInvestorCount: '=',
        packageInvestorCount: '=',
        searchText: '=',
        filterIndicationText: '=?',
        updateDisable: '=',
        onExport: '=',
        onSaveSearch: '=',
        savedSearchList: '=',
        onSaveApply: '=',
        onSaveDelete: '=',
    },

    template: investorListTemplate,

    controller: function (
        $scope,
        $state,
        $ionicLoading,
        $ionicModal,
        ApiInvestors,
        ApiUser,
        filterHistory,
        $filter,
        $rootScope,
        ApiSelections,
        ApiCampaigns,
        FileSaver,
        MessageBox,
        ApiPicklist,
        sentEmailPopup
    ) {
        ApiUser.getUser().then((user) => {
            this.user = user;
        });

        this.MessageBox = MessageBox;
        this.FileSaver = FileSaver;
        this.package = [];
        this.ApiInvestors = ApiInvestors;
        this.ApiCampaigns = ApiCampaigns;
        this.ApiPicklist = ApiPicklist;
        this.subtypes = [];
        this.modal = $ionicModal.fromTemplate(investorListFilterModalTemplate, {
            scope: $scope,
        });
        this.contactCampaignmodal = $ionicModal.fromTemplate(
            investorContactCampaignModalTemplate,
            { scope: $scope }
        );
        this.loading = [];
        this.filterHistory = filterHistory;
        this.$state = $state;

        this.aumRanges = [
            { min: null, max: 1000000, value: '< 1,000,000' },
            { min: 1000000, max: 500000000, value: '1,000,000 - 500,000,000' },
            {
                min: 500000000,
                max: 1000000000,
                value: '500,000,000 - 1,000,000,000',
            },
            {
                min: 1000000000,
                max: 10000000000,
                value: '1,000,000,000 - 10,000,000,000',
            },
            {
                min: 10000000000,
                max: 50000000000,
                value: '10,000,000,000 - 50,000,000,000',
            },
            { min: 50000000000, max: null, value: '> 50,000,000,000' },
        ];

        this.assetAllocations = [];

        this.filterParameter = {
            subtypes: [],
            assetAllocationTypes: [],
            assetAllocations: [],
        };
        this.filterParameterObj = {
            investorType: undefined,
            subtypes: [],
            assetAllocationTypes: [],
            selectionId: undefined,
            fromAum: undefined,
            toAum: undefined,
            searchText: undefined,
            firstQueryResult: undefined,
            sortOrder: 'AUM',
            sortDirection: 'DESC',
        };

        this.packageMoreData = false;
        this.loadingData = true;

        this.$onInit = () => {
            this.ApiPicklist.retrieveAssetClasses().then((data) => {
                this.assetAllocations = data.data;

                if (!this.filterParameter.assetAllocations) {
                    this.filterParameter.assetAllocations = angular.copy(
                        this.assetAllocations
                    );
                }
            });

            this.preLoadFilter();

            // Investor Package (selections)
            ApiSelections.getSelectionsMinimal().then((packages) => {
                this.packageOne = packages || [];
            });

            this.ApiInvestors.getInvestorsSubtypes().then((subtypes) => {
                if (subtypes) {
                    this.subtypes = subtypes.map((subtype) => {
                        return { value: subtype };
                    });

                    if (!this.filterParameter.subtypes) {
                        this.filterParameter.subtypes = angular.copy(
                            this.subtypes
                        );
                    }
                }
            });
            this.loadInvestors();

            this.assignedContacts = new Set();
            this.assignedCustomContacts = new Set();
        };

        var self = this;
        $rootScope.$on(
            '$stateChangeStart',
            function (event, toState, toParams, fromState, fromParam) {
                if (self.closeModal() != null) self.closeModal();
            }
        );

        this.loadInvestors = () => {
            this.loadPackageInvestors();
            if (
                !this.filterParameterObj.selectionId &&
                this.filterParameterObj.assetAllocationTypes.length === 0
            ) {
                this.loadTeamInvestors();
            } else {
                this.teamInvestors = [];
                this.teamMoreData = false;
                this.teamInvestorCount = 0;
            }
        };

        this.loadPackageInvestors = () => {
            this.ApiInvestors.getPackageInvestors(this.filterParameterObj).then(
                (investors) => {
                    if (investors.length < 50) {
                        this.packageMoreData = false;
                    } else {
                        this.packageMoreData = true;
                    }

                    this.packageInvestors = investors || [];
                    this.loadingData = false;
                }
            );

            this.ApiInvestors.getPackageInvestorsCount(
                this.filterParameterObj
            ).then((response) => {
                this.packageInvestorCount = response || 0;
            });
        };

        this.loadTeamInvestors = () => {
            this.ApiInvestors.getTeamInvestors(this.filterParameterObj).then(
                (investors) => {
                    if (investors.length < 50) {
                        this.teamMoreData = false;
                    } else {
                        this.teamMoreData = true;
                    }

                    this.teamInvestors = investors || [];
                    this.loadingData = false;
                }
            );

            this.ApiInvestors.getTeamInvestorsCount(
                this.filterParameterObj
            ).then((response) => {
                this.teamInvestorCount = response || 0;
            });
        };

        this.addToCampaign = (investor, isCustomerInvestor) => {
            this.isCustomerAccount = isCustomerInvestor;
            this.showCheckboxes = false;

            this.ApiCampaigns.getAllChildCampaigns().then((campaigns) => {
                this.campaigns = campaigns || [];
            });
            this.contactCampaignmodal.show();

            this.ApiInvestors.getInvestor(investor.investorId, {
                isCustomerAccount: isCustomerInvestor,
            }).then((res) => {
                if (typeof res != 'undefined') {
                    this.campaignContacts = res.contacts;
                }
            });
        };

        this.selectCampaign = (campaign) => {
            this.campaignSelected = true;
            this.selectedCampaignId = campaign.campaignId;
            this.selectedCampaignTitle = campaign.campaignTitle;
        };

        this.addContactstoCampaign = () => {
            var assignPromises = [];

            if (this.assignedContacts.size > 0) {
                assignPromises.push(
                    ApiCampaigns.putCampaignContacts(
                        this.selectedCampaignId,
                        this.assignedContacts
                    )
                );
            }

            if (this.assignedCustomContacts.size > 0) {
                assignPromises.push(
                    ApiCampaigns.putCampaignCustomerContacts(
                        this.selectedCampaignId,
                        this.assignedCustomContacts
                    )
                );
            }

            Promise.all(assignPromises).then(() => {
                this.$state.go(
                    'campaignDetail',
                    { campaignId: this.selectedCampaignId },
                    { reload: true }
                );
            });
        };
        this.addToContactList = (contact) => {
            if (contact.checked) {
                this.isCustomerAccount
                    ? this.assignedCustomContacts.add(contact.id)
                    : this.assignedContacts.add(contact.id);
            } else {
                this.isCustomerAccount
                    ? this.assignedCustomContacts.delete(contact.id)
                    : this.assignedContacts.delete(contact.id);
            }
        };

        this.showSaveCampaign = () => {
            if (this.isCustomerAccount) {
                return this.assignedCustomContacts.size > 0 ? true : false;
            } else {
                return this.assignedContacts.size > 0 ? true : false;
            }
        };

        this.getMorePackageInvestors = () => {
            this.loadingData = true;
            this.filterParameterObj.firstQueryResult =
                this.packageInvestors && this.packageInvestors.length;
            this.ApiInvestors.getPackageInvestors(this.filterParameterObj).then(
                (investors) => {
                    if (!investors) {
                        this.packageMoreData = false;
                    } else {
                        this.packageMoreData =
                            investors.length < 50 ? false : true;
                        this.packageInvestors =
                            this.packageInvestors.concat(investors);
                        $scope.$broadcast('scroll.infiniteScrollComplete');
                    }
                    this.loadingData = false;
                }
            );
        };

        this.getMoreTeamInvestors = () => {
            this.loadingData = true;
            this.filterParameterObj.firstQueryResult =
                this.teamInvestors && this.teamInvestors.length;
            this.ApiInvestors.getTeamInvestors(this.filterParameterObj).then(
                (investors) => {
                    if (!investors) {
                        this.teamMoreData = false;
                    } else {
                        this.teamMoreData =
                            investors.length < 50 ? false : true;
                        this.teamInvestors =
                            this.teamInvestors.concat(investors);
                        $scope.$broadcast('scroll.infiniteScrollComplete');
                    }
                    this.loadingData = false;
                }
            );
        };

        this.deleteInvestor = (investor, index) => {
            this.showLoading();
            this.ApiInvestors.deleteInvestor(investor.investorId).then(
                (res) => {
                    if (res == null) {
                        this.teamInvestors.splice(index, 1);
                        this.teamInvestorCount--;
                    }
                    this.hideLoading();
                }
            );
        };

        // Show filter modal box
        this.openModal = () => {
            this.subtypes.forEach((subtype) => {
                if (this.filterParameterObj.subtypes.includes(subtype.value)) {
                    subtype.checked = true;
                } else {
                    subtype.checked = false;
                }
            });

            this.assetAllocations.forEach((level1) => {
                level1.checked =
                    this.filterParameterObj.assetAllocationTypes.includes(
                        level1.field
                    );

                if (level1.items && level1.items.length > 0) {
                    level1.items.forEach((level2) => {
                        level2.checked =
                            this.filterParameterObj.assetAllocationTypes.includes(
                                level2.field
                            );
                        if (level2.items && level2.items.length > 0) {
                            level2.items.forEach((level3) => {
                                level3.checked =
                                    this.filterParameterObj.assetAllocationTypes.includes(
                                        level3.field
                                    );
                            });
                        }
                    });
                }
            });

            this.filterParameter.subtypes = angular.copy(this.subtypes);
            this.filterParameter.assetAllocations = angular.copy(
                this.assetAllocations
            );

            this.updateDisable(true);
            var self = this;
            this.modal.scope.$on('modal.hidden', () => {
                self.updateDisable(false);
            });
            this.modal.show();
        };

        // Close filter modal box
        this.closeModal = () => {
            this.modal.hide();
            this.contactCampaignmodal.hide();
        };

        this.cancelModal = () => {
            this.campaignSelected = false;
            this.filterParameter.subtypes = this.subtypes;
            this.showCheckboxes = false;
            delete this.selectedCampaign;

            this.assignedCustomContacts.clear();
            this.assignedContacts.clear();
            this.closeModal();
        };

        this.showChildren = (id, parent) => {
            switch (parent) {
                case 'packageOne':
                    this.packageTwo = undefined;
                    this.packageThree = undefined;
                    this.packageFour = undefined;
                    if (id) {
                        ApiSelections.getSelectionChildren(id).then(
                            (packagesTwo) => {
                                this.packageTwo = packagesTwo || [];
                            }
                        );
                    }
                    break;
                case 'packageTwo':
                    this.packageThree = undefined;
                    this.packageFour = undefined;
                    if (id) {
                        ApiSelections.getSelectionChildren(id).then(
                            (packagesThree) => {
                                this.packageThree = packagesThree || [];
                            }
                        );
                    }
                    break;
                case 'packageThree':
                    this.packageFour = undefined;
                    if (id) {
                        ApiSelections.getSelectionChildren(id).then(
                            (packagesFour) => {
                                this.packageFour = packagesFour || [];
                            }
                        );
                    }
                    break;
                default:
                    return false;
            }
        };

        // Handle when user clicks filter-go button
        this.onFilter = () => {
            this.populateFilterCriteria();

            this.filterHistory.saveFilter(
                angular.copy(this.filterParameter),
                'investor'
            );
            this.loadPackageInvestors();
            if (
                !this.filterParameterObj.selectionId &&
                this.filterParameterObj.assetAllocationTypes.length === 0
            ) {
                this.loadTeamInvestors();
            } else {
                this.teamInvestors = [];
                this.teamMoreData = false;
                this.teamInvestorCount = 0;
            }
            this.getFilterIndicationText();
            this.closeModal();
        };

        // Remove filter
        this.removeInvestorType = () => {
            if (this.filterParameter.investorType) {
                delete this.filterParameter.investorType;
            }

            this.onFilter();
        };

        this.removeSubType = (subType) => {
            subType.checked = false;
            this.onFilter();
        };
        this.removeAllocationType = (allocationType) => {
            allocationType.checked = false;
            this.onFilter();
        };
        this.removeAllFilters = () => {
            if (this.filterParameter.investorType) {
                delete this.filterParameter.investorType;
            }
            this.filterParameter.assetAllocations.map((level1) => {
                level1.checked = false;
                if (level1.items && level1.items.length > 0) {
                    level1.items.map((level2) => {
                        level2.checked = false;
                        if (level2.items && level2.items.length > 0) {
                            level2.items.map((level3) => {
                                level3.checked = false;
                            });
                        }
                    });
                }
            });
            this.filterParameter.assetAllocationTypes.map((item) => {
                item.checked = false;
            });
            this.filterParameter.subtypes.map((item) => {
                item.checked = false;
            });

            if (this.filterParameter.aum) {
                delete this.filterParameter.aum;

                this.filterParameterObj.fromAum = undefined;
                this.filterParameterObj.toAum = undefined;
            }

            if (this.filterParameter.package) {
                delete this.filterParameter.package;
                delete this.filterParameter.packageOne;
                delete this.filterParameter.packageTwo;
                delete this.filterParameter.packageThree;

                this.filterParameterObj.selectionId = undefined;
            }

            this.onFilter();
        };

        this.removeAUM = () => {
            if (this.filterParameter.aum) {
                delete this.filterParameter.aum;

                this.filterParameterObj.fromAum = undefined;
                this.filterParameterObj.toAum = undefined;
            }

            this.onFilter();
        };

        this.removePackage = () => {
            if (this.filterParameter.package) {
                delete this.filterParameter.package;
                delete this.filterParameter.packageOne;
                delete this.filterParameter.packageTwo;
                delete this.filterParameter.packageThree;

                this.filterParameterObj.selectionId = undefined;
            }

            this.onFilter();
        };

        this.showLoading = () => {
            this.loading.push(1);
            $ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>',
            });
        };

        this.hideLoading = () => {
            this.loading.pop();
            if (this.loading.length === 0) $ionicLoading.hide();
        };

        this.preLoadFilter = () => {
            let filter = this.filterHistory.readFilter('investor');
            if (filter) {
                this.filterParameter = filter;
                this.populateFilterCriteria();
                this.getFilterIndicationText();
            }
        };

        this.populateFilterCriteria = () => {
            this.filterParameterObj.subtypes = [];
            this.filterParameter.subtypes.forEach((subtype) => {
                if (subtype.checked) {
                    this.filterParameterObj.subtypes.push(subtype.value);
                }
            });

            this.filterParameterObj.assetAllocationTypes = [];

            if (this.filterParameter.assetAllocations) {
                this.filterParameter.assetAllocations.forEach((level1) => {
                    if (level1.checked && level1.field !== null) {
                        this.filterParameterObj.assetAllocationTypes.push(
                            level1.field
                        );
                    }

                    if (level1.items && level1.items.length > 0) {
                        level1.items.forEach((level2) => {
                            if (level2.checked && level2.field !== null) {
                                this.filterParameterObj.assetAllocationTypes.push(
                                    level2.field
                                );
                            }

                            if (level2.items && level2.items.length > 0) {
                                level2.items.forEach((level3) => {
                                    if (
                                        level3.checked &&
                                        level3.field !== null
                                    ) {
                                        this.filterParameterObj.assetAllocationTypes.push(
                                            level3.field
                                        );
                                    }
                                });
                            }
                        });
                    }
                });
            }

            if (this.filterParameter.aum) {
                this.filterParameterObj.fromAum = this.filterParameter.aum.min;
                this.filterParameterObj.toAum = this.filterParameter.aum.max;
            } else {
                this.filterParameterObj.fromAum = undefined;
                this.filterParameterObj.toAum = undefined;
            }
            this.filterParameterObj.firstQueryResult = undefined;
            this.filterParameterObj.searchText =
                this.filterParameter.searchText;
            if (this.filterParameter.searchText) {
                this.searchText = this.filterParameter.searchText;
            }

            // add selected package to filterParameterObj
            if (this.filterParameter.packageFour) {
                this.filterParameter.package = this.filterParameter.packageFour;
                this.filterParameterObj.selectionId =
                    this.filterParameter.packageFour.selectionId;
            } else if (this.filterParameter.packageThree) {
                this.filterParameter.package =
                    this.filterParameter.packageThree;
                this.filterParameterObj.selectionId =
                    this.filterParameter.packageThree.selectionId;
            } else if (this.filterParameter.packageTwo) {
                this.filterParameter.package = this.filterParameter.packageTwo;
                this.filterParameterObj.selectionId =
                    this.filterParameter.packageTwo.selectionId;
            } else if (this.filterParameter.packageOne) {
                this.filterParameter.package = this.filterParameter.packageOne;
                this.filterParameterObj.selectionId =
                    this.filterParameter.packageOne.selectionId;
            } else {
                this.filterParameter.package = undefined;
                this.filterParameterObj.selectionId = undefined;
            }
        };

        this.checkAssetAllocation = (level) => {
            const element = this.filterParameterObj.assetAllocationTypes.find(
                (item) => item === level.field
            );
            return element !== undefined;
        };

        this.reverseFilter = () => {
            this.filterParameter.subtypes = angular.copy(this.subtypes);
            this.filterParameter.assetAllocations = angular.copy(
                this.assetAllocations
            );

            this.filterParameter.subtypes.forEach((subtype) => {
                subtype.checked =
                    this.filterParameterObj.subtypes.indexOf(subtype.value) !==
                    -1;
            });

            this.filterParameter.assetAllocations.forEach((level1) => {
                level1.checked = this.checkAssetAllocation(level1);

                if (level1.items && level1.items.length > 0) {
                    level1.items.forEach((level2) => {
                        level2.checked = this.checkAssetAllocation(level2);

                        if (level2.items && level2.items.length > 0) {
                            level2.items.forEach((level3) => {
                                level3.checked =
                                    this.checkAssetAllocation(level3);
                            });
                        }
                    });
                }
            });

            if (
                this.filterParameterObj.fromAum ||
                this.filterParameterObj.toAum
            ) {
                this.filterParameter.aum = {
                    min: this.filterParameterObj.fromAum,
                    max: this.filterParameterObj.toAum,
                    value: this.getAumValue(
                        this.filterParameterObj.fromAum,
                        this.filterParameterObj.toAum
                    ),
                };
            } else {
                this.filterParameter.aum = undefined;
            }

            this.filterParameter.searchText =
                this.filterParameterObj.searchText;
            this.searchText = this.filterParameter.searchText;

            if (
                this.packageFour &&
                this.isPackage(
                    this.packageFour,
                    this.filterParameterObj.selectionId
                )
            ) {
                this.filterParameter.package = this.isPackage(
                    this.packageFour,
                    this.filterParameterObj.selectionId
                );
                this.filterParameter.packageFour = this.filterParameter.package;
            } else if (
                this.packageThree &&
                this.isPackage(
                    this.packageThree,
                    this.filterParameterObj.selectionId
                )
            ) {
                this.filterParameter.package = this.isPackage(
                    this.packageThree,
                    this.filterParameterObj.selectionId
                );
                this.filterParameter.packageThree =
                    this.filterParameter.package;
            } else if (
                this.packageTwo &&
                this.isPackage(
                    this.packageTwo,
                    this.filterParameterObj.selectionId
                )
            ) {
                this.filterParameter.package = this.isPackage(
                    this.packageTwo,
                    this.filterParameterObj.selectionId
                );
                this.filterParameter.packageTwo = this.filterParameter.package;
            } else if (
                this.packageOne &&
                this.isPackage(
                    this.packageOne,
                    this.filterParameterObj.selectionId
                )
            ) {
                this.filterParameter.package = this.isPackage(
                    this.packageOne,
                    this.filterParameterObj.selectionId
                );
                this.filterParameter.packageOne = this.filterParameter.package;
            } else {
                delete this.filterParameter.package;
                delete this.filterParameter.packageOne;
                delete this.filterParameter.packageTwo;
                delete this.filterParameter.packageThree;

                this.filterParameterObj.selectionId = undefined;
            }
        };

        this.getAumValue = (min, max) => {
            const item = this.aumRanges.find((item) => {
                return item.min == min && item.max == max;
            });

            return item ? item.value : null;
        };

        this.isPackage = (packageItem, sectionId) => {
            return packageItem.find((item) => {
                return item.selectionId === sectionId;
            });
        };

        this.onSearch = (search) => {
            this.filterParameter.searchText = search;
            this.onFilter();
        };

        this.selectAllLevel1 = (level1) => {
            let state = level1.checked;

            level1.checked = state;
            if (level1.items && level1.items.length > 0) {
                level1.items = level1.items.map((item) => {
                    item.checked = state;

                    if (item.items && item.items.length > 0) {
                        item.items = item.items.map((subitem) => {
                            subitem.checked = state;
                            return subitem;
                        });
                    }

                    return item;
                });
            }
        };

        this.selectAllLevel2 = (level2) => {
            let state = level2.checked;

            level2.checked = state;
            if (level2.items && level2.items.length > 0) {
                level2.items = level2.items.map((item) => {
                    item.checked = state;
                    return item;
                });
            }
        };

        this.onSort = (field, order) => {
            this.filterParameterObj.sortDirection = order;
            this.filterParameterObj.sortOrder = field;
            this.onFilter();
        };

        this.getFilterIndicationText = () => {
            let filter = this.filterParameter;

            let text = '';
            if (!filter) return '';
            let investorExists = filter.subtypes.some((i) => {
                return i.checked;
            });
            let assetClassesExists = false;
            if (filter.assetAllocations) {
                assetClassesExists = filter.assetAllocations.some((item) => {
                    let level2 = false;
                    if (item.items && item.items.length > 0) {
                        level2 = item.items.some((subitem) => {
                            let level3 = false;
                            if (subitem.items && subitem.items.length > 0) {
                                level3 = subitem.items.some((subsubitem) => {
                                    return subsubitem.checked;
                                });
                            }

                            return subitem.checked || level3;
                        });
                    }

                    return item.checked || level2;
                });
            }

            if (filter.package)
                text = text + $filter('translate')('PACKAGE') + ', ';
            if (filter.aum) text = text + $filter('translate')('AUM') + ', ';
            if (investorExists)
                text = text + $filter('translate')('INVESTOR_TYPES') + ', ';
            if (assetClassesExists)
                text = text + $filter('translate')('ASSET_ALLOCATION') + ', ';
            if (text.length > 0) {
                text = 'Filter by: ' + text.substring(text.length - 2, 0);
            }
            this.filterIndicationText = text;
        };
        this.toggleAssetAllocation = () => {
            this.showAssetAllocation = !this.showAssetAllocation;
        };
        this.toggleInvestorType = () => {
            this.showInvestorType = !this.showInvestorType;
        };

        this.getInvestorUrl = (investorId) => {
            return $state.href('investorsDetail', {
                investorId: investorId,
                isCustomerInvestor: false,
                advindaCount: this.packageInvestorCount,
                customCount: this.teamInvestorCount,
            });
        };

        this.getCustomInvestorUrl = (investorId) => {
            return $state.href('customerInvestorsDetail', {
                investorId: investorId,
                isCustomerInvestor: true,
                advindaCount: this.packageInvestorCount,
                customCount: this.teamInvestorCount,
            });
        };

        this.emailInvestors = () => {
            $ionicLoading.show();
            this.ApiInvestors.emailInvestors(this.filterParameterObj).then(
                (_) => {
                    $ionicLoading.hide();
                    this.MessageBox.showSuccessMessage(
                        'EXPORT_INVESTOR',
                        'SENT'
                    );
                }
            );
        };

        this.onExport = () => {
            sentEmailPopup.show(
                `${this.user.firstName} ${this.user.name}`,
                this.emailInvestors
            );
        };

        this.onSaveSearch = (name) => {
            this.ApiInvestors.postSavedSearch({
                filter: this.filterParameterObj,
                filterName: name,
            }).then((data) => {
                if (data) {
                    this.MessageBox.showSuccessMessage('SEARCH', 'SAVED');
                }
            });
        };

        this.savedSearchList = () => {
            return this.ApiInvestors.getSavedSearch();
        };

        this.onSaveApply = (filter) => {
            this.filterParameterObj = angular.copy(filter);
            this.reverseFilter();
            this.onFilter();
        };

        this.onSaveDelete = (name) => {
            this.ApiInvestors.deleteSavedSearch(name);
            // this.MessageBox.showSuccessMessage('SEARCH', 'DELETED');
        };

        this.isAssetAllocationFilter = () => {
            let filter = this.filterParameter;
            let assetClassesExists = false;

            if (filter.assetAllocations) {
                assetClassesExists = filter.assetAllocations.some((item) => {
                    let level2 = false;
                    if (item.items && item.items.length > 0) {
                        level2 = item.items.some((subitem) => {
                            let level3 = false;
                            if (subitem.items && subitem.items.length > 0) {
                                level3 = subitem.items.some((subsubitem) => {
                                    return subsubitem.checked;
                                });
                            }

                            return subitem.checked || level3;
                        });
                    }

                    return item.checked || level2;
                });
            }

            return assetClassesExists;
        };
    },
};

export default investorFilterModal;



/** WEBPACK FOOTER **
 ** ./src/app/directives/investorList/investorList.js
 **/